"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EtikettInfo = exports.EtikettSuksess = exports.EtikettFokus = exports.EtikettAdvarsel = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_typografi_1 = __importDefault(require("nav-frontend-typografi"));
require("nav-frontend-etiketter-style");
const cls = (type, mini, className) => (0, classnames_1.default)("etikett", className, {
    "etikett--advarsel": type === "advarsel",
    "etikett--fokus": type === "fokus",
    "etikett--suksess": type === "suksess",
    "etikett--info": type === "info",
    "etikett--mini": mini,
});
class EtikettBase extends React.Component {
    render() {
        const _a = this.props, { type, className, typo, children, mini } = _a, props = __rest(_a, ["type", "className", "typo", "children", "mini"]);
        let typografi = mini ? "undertekst" : "normaltekst";
        typografi = typo || typografi;
        return (React.createElement("div", Object.assign({ className: cls(type, mini, className) }, props),
            React.createElement(nav_frontend_typografi_1.default, { tag: "span", type: typografi }, children)));
    }
}
EtikettBase.propTypes = {
    /**
     * Typografi som skal brukes i etiketten. Støtter samme typer som `TypografiBase`. Påvirker ikke tag...
     */
    typo: PT.string,
    children: PT.node.isRequired,
    /**
     * Predefinerte farger
     */
    type: PT.oneOf(["suksess", "info", "fokus", "advarsel"]).isRequired,
    className: PT.string,
    /**
     * Tettere 24px høy, 14px font-size versjon
     */
    mini: PT.bool,
};
EtikettBase.defaultProps = {
    className: undefined,
    mini: false,
};
exports.default = EtikettBase;
var etikettadvarsel_1 = require("./etikettadvarsel");
Object.defineProperty(exports, "EtikettAdvarsel", { enumerable: true, get: function () { return __importDefault(etikettadvarsel_1).default; } });
var etikettfokus_1 = require("./etikettfokus");
Object.defineProperty(exports, "EtikettFokus", { enumerable: true, get: function () { return __importDefault(etikettfokus_1).default; } });
var etikettsuksess_1 = require("./etikettsuksess");
Object.defineProperty(exports, "EtikettSuksess", { enumerable: true, get: function () { return __importDefault(etikettsuksess_1).default; } });
var etikettinfo_1 = require("./etikettinfo");
Object.defineProperty(exports, "EtikettInfo", { enumerable: true, get: function () { return __importDefault(etikettinfo_1).default; } });
